import { render } from "./indextwomenu.vue?vue&type=template&id=54764ea5"
import script from "./indextwomenu.vue?vue&type=script&lang=js"
export * from "./indextwomenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__